/* jshint esversion: 6 */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Nav from 'app/components/common/Nav.jsx';
import MobileNav from 'app/components/common/MobileNav.jsx';

import UserMessages from 'app/modules/UserMessageModule.js';

import ConstantMixin from 'app/mixins/ConstantMixin.js';
import InfoBanner from 'app/components/InfoBanner/InfoBanner.jsx';
import { AnimatePresence } from 'motion/react';
import TrialBanner from 'app/components/InfoBanner/Banners/TrialBanner.jsx';
import PastDueBanner from 'app/components/InfoBanner/Banners/PastDueBanner.jsx';
import LocalStorageBanner from 'app/components/InfoBanner/Banners/LocalStorageBanner.jsx';
import SocialDisconnectBanner from 'app/components/InfoBanner/Banners/SocialDisconnectBanner.jsx';
import CardlessTrialBanner from 'app/components/InfoBanner/Banners/CardlessTrialBanner.jsx';
import ReconnectSocialModal from 'app/components/ReconnectModal/ReconnectSocialModal.jsx';
import SetPassword from '@/shadcn/components/signup/SetPassword.tsx';
import NewSocialSuggestFeedsModal from '@/shadcn/components/social/NewSocialSuggestFeedsModal.tsx';
import RateLimitModal from 'app/components/RateLimitModal/RateLimitModal.jsx';
import BasicBanner from 'app/components/InfoBanner/Banners/BasicBanner.jsx';
import ProBanner from 'app/components/InfoBanner/Banners/ProBanner.jsx';
import PlusBanner from 'app/components/InfoBanner/Banners/PlusBanner.jsx';
import PauseBanner from 'app/components/InfoBanner/Banners/PauseBanner.jsx';
import EmailValidationBanner from 'app/components/InfoBanner/Banners/EmailValidationBanner.jsx';
import TwitterFubarModal from 'app/components/common/TwitterFubarModal.jsx';
import TrialEndingModal from 'app/components/Subscription/TrialEndingModal.jsx';
import TrialEndedModal from 'app/components/Subscription/TrialEndedModal.jsx';
import RecurlySubscriptionPausedModal from 'app/components/Subscription/RecurlySubscriptionPausedModal.jsx';
import WelcomeBack from 'app/components/common/WelcomeBack.jsx';
import XQrCodesNotice, { xQrCodesNoticeApplies, xQrCodesNoticeSeen } from 'app/components/common/XQrCodesNotice.jsx';

import SubscriptionPauseModal from 'app/components/Subscription/SubscriptionPauseModal.jsx';

import AppProvider from 'app/redux/Providers/AppProvider.jsx';
import UserProvider from 'app/redux/Providers/UserProvider.jsx';
import UtilityProvider from 'app/redux/Providers/UtilityProvider.jsx';
import ModalProvider from 'app/redux/Providers/ModalProvider.jsx';
import SocialProvider from 'app/redux/Providers/SocialProvider.jsx';
import AuthModule from 'app/mixins/AuthModule.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import PlanProvider from 'app/redux/Providers/PlanProvider.jsx';
import RouteProvider from 'app/redux/Providers/RouteProvider.jsx';
import NotificationProvider from 'app/redux/Providers/NotificationProvider.jsx';
import SocialConnectModule from 'app/modules/SocialConnectModule.jsx';

import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import IntercomWidgetControl from 'app/components/common/IntercomWidgetControl.jsx';
import { bootIntercom, startIdentityRefresh } from 'app/utility/Intercom.js';

import Sidebar from 'app/components/common/SideBar.jsx';
import Content from 'app/components/common/Content.jsx';
import Loading from 'app/components/common/Loading.jsx';

import TrialWidget from 'app/components/Subscription/TrialWidget.jsx';

import { compose } from 'redux';
import * as _ from 'underscore';
import { Link, Outlet } from 'react-router-dom';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';

import PersistData from 'app/mixins/PersistData.jsx';

import { Breakpoint } from 'react-socks';

import MobileOnlyBanner from 'app/components/common/MobileOnlyBanner.jsx';

import { Toaster } from "@/shadcn/components/ui/sonner"
import makeToast from 'app/modules/makeToast.js'
import reportSocialBatch from 'app/modules/reportSocialBatch.js';
import posthog from 'posthog-js'

class App extends React.Component {
	constructor(props) {
		super(props);

		let bannerVisible = true,
			trialEndingAcknowledged = false,
			localStorageNotice = false,
			showTrialEndModal = true;

		if (typeof(Storage) !== undefined) {
			if (window.sessionStorage.hasOwnProperty('bannerVisible')) {
				bannerVisible = window.sessionStorage['bannerVisible'];
				if (bannerVisible === "false") {
					bannerVisible = false;
				}
			}
			if (JSON.parse(window.localStorage.getItem('onboarding'))) {
				bannerVisible = false;
			}
			if (window.sessionStorage.hasOwnProperty('trialEndingAcknowledged')) {
				trialEndingAcknowledged = window.sessionStorage['trialEndingAcknowledged'];
				if (trialEndingAcknowledged === "true") {
					showTrialEndModal = false;
				}
			}
		}

		try {
			if (typeof(Storage) !== undefined) {
				window.localStorage.setItem('privateTest', 1);
				window.localStorage.removeItem('privateTest');

				if (window.localStorage.getItem('e2eTest')) {
					localStorageNotice = true;
				}
			}
		} catch (err) {
			localStorageNotice = true;
		}

		let isTwitterFubar = false;
		if (props.app.config.twitterDisabled !== undefined && props.app.config.twitterDisabled) {
			isTwitterFubar = true;
		}

		this.state = {
			curateRouteID: {},
			notices: [],
			avatar: '',
			username: '',
			savedPath: '',
			bannerVisible: bannerVisible,
			pastDue: 0,
			localStorageNotice: localStorageNotice,
			marketing: true,
			bannerSuppressed: false,
			showReconnectModal: false,
			showFacebookProfileNotice: true,
			showRateLimitToast: false,
			showSetPasswordModal: false,
			showTwitterFubarModal: isTwitterFubar,
			showTrialEndModal: showTrialEndModal,
			showWelcomeBackModal: false,
			xQrCodesNoticeDone: xQrCodesNoticeSeen(),
			setPasswordModalAcknowledged: false,
			suggestFeedsSocialID: 0,
			pollID: 0,
			isOnboarding: false,
			promptBatchSocial: false
		};

		this.recordPath = this.recordPath.bind(this);
		this.getSavedPath = this.getSavedPath.bind(this);
		this.closeInfoBanner = this.closeInfoBanner.bind(this);
		this.dismissModal = this.dismissModal.bind(this);
		this.showSuggestFeedsModal = this.showSuggestFeedsModal.bind(this);
		this.hideSuggestFeedsModal = this.hideSuggestFeedsModal.bind(this);
		this.userHasFeeds = this.userHasFeeds.bind(this);

		this.toasterRef = React.createRef();

	}

	static getDerivedStateFromProps(props, state) {

		if ((window.location.pathname.match('subscription')) ||
			(window.location.pathname.match('promo'))) {
			if (!state.bannerSuppressed) {
				return {
					bannerSuppressed: true,
					bannerVisible: false
				};
			}
		} else {
			if (state.bannerSuppressed) {
				return {
					bannerSuppressed: false,
					bannerVisible: true
				};
			}
		}

		// add support for showing the social disconnect banner and modal
		// based on a param from the query
		if (window.location.search.match('reconnect=true')) {
			if (!state.showReconnectModal) {
				return {
					showReconnectModal: true
				};
			}
		}

		if (props.app.config.twitterDisabled !== undefined && props.app.config.twitterDisabled) {
			let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
			if (document.cookie && !onboarding) {
				var entries = document.cookie.split("; ");
				for (var i = 0; i < entries.length; ++i) {
					var data = [],
						cookieData = {};

					if (entries[i].match('twitterNotice')) {
						data = entries[i].split("=");
						cookieData = JSON.parse(decodeURIComponent(data[1]));

						if (cookieData.hideTwitterFubarNotice && cookieData.hideTwitterFubarNotice === 1) {
							return {
								showTwitterFubarModal: false
							};
						}
					}
				}
			}

			if (onboarding) {
				return {
					showTwitterFubarModal: false
				};
			}
		}

		return null;

	}

	componentDidMount() {

		startIdentityRefresh(this.props.getIntercomToken);
		bootIntercom(this.props.user.detail);

		this.props.getUser();
		this.props.getUserPlan();
		this.props.getUserPerms();
		this.props.getRoutes();
		this.props.getSocialInputCreds();
		this.props.getSocials();



	}

	componentDidUpdate(prevProps, prevState) {

		// if (this.props.app.configLoaded === true && prevProps.app.configLoaded === false) {
		// 	this.props.getUser();
		// 	this.props.getUserPlan();
		// 	this.props.getUserPerms();
		// 	this.props.getRoutes();
		// }

		let constants = this.props.app.config.constants

		// The token comparison covers both a scheduled identity refresh and the
		// fresh token that rides along on any account fetch or profile update —
		// without it the Messenger keeps whichever token it booted with.
		if (prevProps.user.detail.email !== this.props.user.detail.email ||
			prevProps.user.detail.id !== this.props.user.detail.id ||
			prevProps.user.detail.intercomJwt !== this.props.user.detail.intercomJwt) {
			bootIntercom(this.props.user.detail);
		}

		// Need to be able to track the state between onboarding and not to show the trial banner ASAP
		if (typeof(Storage) !== undefined) {
			let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
			if (onboarding && !this.state.isOnboarding) {
				this.setState({
					isOnboarding: true
				});
			} else if (!onboarding && this.state.isOnboarding) {
				this.setState({
					isOnboarding: false
				});
			}
		}

		if (prevState.isOnboarding && !this.state.isOnboarding) {
			this.setState({
				bannerVisible: true
			});
		}

		if (prevProps && prevProps.app.loading.SUB_PAUSE_SUBSCRIPTION === true && this.props.app.loading.SUB_PAUSE_SUBSCRIPTION === false) {
			// modal will handle any error display
			let pauseErrors = this.props.getApiErrors(['SUB_PAUSE_SUBSCRIPTION']);
			if (!pauseErrors.length) {
				this.props.getUser();
				this.props.getUserPlan();
			}
		}

		// update perms when users take actions to affect resource usage
		if ((prevProps.socials.list.length > 0 && prevProps.socials.list.length !== this.props.socials.list.length) ||
			(prevProps.automatedRoutes.list.length > 0 && prevProps.automatedRoutes.list.length !== this.props.automatedRoutes.list.length)) {
			this.props.getUserPerms();
		}

		if (prevProps.app.userSessionActive === true && this.props.app.userSessionActive === false) {
			window.location.href = "/login";
		}

		// social batch creation handler
		if (Object.keys(this.props.socials.batchCreates).length) {

			if (!this.state.pollID) {
				let pollID = setTimeout(() => {
					this.props.createBatchPoll({
						pubID: this.props.user.detail.id
					});
					this.setState({
						pollID: 0
					});
				}, 1500);
				this.setState({
					pollID
				});
			}

			if (Object.keys(prevProps.socials.batchCreates).length === 0 && Object.keys(this.props.socials.batchCreates).length > 0) {
				let profileLabel = 'profiles',
					keys = Object.keys(this.props.socials.batchCreates);
				if (parseInt(this.props.socials.batchCreates[keys[0]]?.total) === 1) {
					profileLabel = "profile";
				}
				makeToast(`Connecting your social ${profileLabel}`, "info");
			}

		} else if (Object.keys(prevProps.socials.batchCreates).length > 0 && Object.keys(this.props.socials.batchCreates).length === 0) {
			this.setState({
				promptBatchSocial: true
			});
			this.props.deleteMessage(["SOCIAL_CREATE_BATCH"]);
			// refresh perms
			this.props.getUserPerms();
			this.props.getSocials(true);
			this.props.getNotices();
			reportSocialBatch(Object.values(prevProps.socials.batchCreates)[0]);

			// if the user is on the automate page, pull the routes
			if (window.location.pathname.match(/\/share\/automate$/)) {
				this.props.getRoutes();
			}
			// if the detail is open, pull that too
			if (window.location.pathname.match(/\/share\/automate\/detail/)) {
				this.props.getRoute(this.props.router.params.routeId);
			}
		}

		// refresh socials just in case a snapshot was applied during subscription create
		if (prevProps && prevProps.app.loading.SUB_CREATE === false && this.props.app.loading.SUB_CREATE === true) {
			let subErrors = this.props.getApiErrors(['SUB_CREATE']);
			if (!subErrors.length) {
				this.props.getSocials(true);
			}
		}

		if (prevProps && (prevProps.app.loading.USER_FETCH === true && this.props.app.loading.USER_FETCH === false) ||
			(prevProps.app.loading.USER_UPDATE === true && this.props.app.loading.USER_UPDATE === false)) {
			let modalSeen = false;

			if (prevProps.app.loading.USER_FETCH === true && this.props.app.loading.USER_FETCH === false) {
				let d = this.props.user.detail;
				posthog.identify(d.id, {
					pub_level: parseInt(d.pubLevel, 10),
					plan: this.props.app.config.constants.SUBSCRIPTION_LABELS_BARE[d.pubLevel],
					subscription_state: parseInt(d.subscriptionState, 10),
					past_due: !!d.pastDue,
					signup_date: d.created,
					is_agent: !!d.isAgent,
					is_client: !!d.isClient
				});
			}

			if (typeof(Storage) !== undefined) {
				if (window.localStorage.getItem('welcomeBackModalSeen') !== null) {
					modalSeen = true;
				}
			}

			if (this.props.user.detail.needsPassword === true) {
				let passwordModalSuppress = "",
					resetStorage = false,
					showSetPasswordModal = true;

				// put off for a week, after which it asks again
				if (window.localStorage.hasOwnProperty('passwordModalSuppress')) {
					passwordModalSuppress = moment(window.localStorage.getItem('passwordModalSuppress'));
					if (passwordModalSuppress.isBefore()) {
						window.localStorage.removeItem('passwordModalSuppress')
					} else {
						showSetPasswordModal = false;
					}
				}

				if (this.state.showSetPasswordModal !== showSetPasswordModal) {
					this.setState({
						showSetPasswordModal
					});
				}
			}

			if (prevProps.user.detail.needsPassword && !this.props.user.detail.needsPassword && this.state.showSetPasswordModal) {
				this.props.closeAllModals();
				this.setState({
					showSetPasswordModal: false,
					setPasswordModalAcknowledged: true
				});
			}

			if ((this.props.user.detail.hasSnapshot || this.props.user.detail.pauseButton === constants.PUB_PAUSE_SYSTEM) &&
				this.props.app.firstLoad.SUB_FETCH_EXPIRED_PLAN === false) {
				this.props.getExpiredPlan();
			}

			if (this.state.showWelcomeBackModal && modalSeen) {
				this.setState({
					showWelcomeBackModal: false
				});
				// refresh the routes in case the user "unpaused" in the special way
				this.props.getRoutes();
			}

			// show the welcome back modal to users who have started a new trial, but haven'thad a
			// subscription in the past and have signed up prior to the beginning of the latest trial
			let createDate = new Date(this.props.user.detail.created),
				trialStart = (this.props.user.detail.trialStart) ? new Date(this.props.user.detail.trialStart) : null;
			if (trialStart &&
				this.props.user.detail.trialState === constants.PUB_TRIAL_STARTED &&
				!moment(createDate).isSame(trialStart, 'day') &&
				!this.props.user.detail.hasHadSubscription && !modalSeen && !this.state.showWelcomeBackModal) {
				this.setState({
					showWelcomeBackModal: true
				});
			}
		}

		if (prevProps && (this.props.app.userLoaded === true && this.props.app.firstLoad.SOCIAL_LIST &&
			this.props.user.detail.pubLevel === constants.PUB_LEVEL_1 && !this.state.showRateLimitToast)) {
			let limitedNetworks = [],
				title = "All posts paused",
				description = null,
				postRenewal = null;

			for (let i = 0; i < this.props.socials.list.length; ++i) {
				if (this.props.socials.list[i].activeFlag && this.props.socials.list[i].postLimit !== undefined &&
					this.props.socials.list[i].postLimit !== 0 && this.props.socials.list[i].postLimitRemaining === 0) {
					let networkName = ConstantMixin.getPostServiceNameByCode(this.props.socials.list[i].psID);
					if (limitedNetworks.indexOf(networkName) === -1) {
						limitedNetworks.push(networkName);
					}
				}
				postRenewal = new moment(this.props.socials.list[i].postLimitReset * 1000).tz(this.props.user.detail.timezone);
			}

			if (limitedNetworks.length && !this.state.showRateLimitToast) {
				if (postRenewal) {
					description = "Monthly limit reached"
					// description = (
					// 	<span>
					// 		Resets {postRenewal.format("MMM D")}
					// 	</span>
					// )
				}
				if (limitedNetworks.length === 1) {
					title = limitedNetworks.join("") + " posts paused";
				} else if (limitedNetworks.length === 2) {
					title = "Posts paused to two profiles"
				}

				let rateLimitToastAcknowledged = window.sessionStorage.getItem("rateLimitToastAcknowledged");

				if (!rateLimitToastAcknowledged) {
					setTimeout(() => {
						makeToast("", "custom", {
							title: title,
							description: description,
							action: {
								label: "Restart",
								onClick: () => {
									this.props.router.navigate("/account/subscription/new")
								}
							},
							closeButton: true,
							duration: Infinity,
							position: "bottom-left",
							dismissible: true,
							onDismiss: () => {
								window.sessionStorage.setItem("rateLimitToastAcknowledged", true)
							}
						});
					}, 1000);

				}

				this.setState({
					showRateLimitToast: true
				});
			}
		}

		if (this.props.app.userLoaded && this.props.app.firstLoad.ROUTE_LIST && this.props.app.firstLoad.SOCIAL_LIST) {
			if (this.props.router.query?.addFeedsToSocial && !this.state.suggestFeedsSocialID) {
				if (this.userHasFeeds()) {
					this.showSuggestFeedsModal(this.props.router.query?.addFeedsToSocial);
				}
				/*
				 * Drop the param the picker was launched with so a reload doesn't
				 * re-open it, keeping any other query the url arrived with —
				 * navigating to the bare pathname would throw those away.
				 */
				let search = new URLSearchParams(this.props.router.location.search);

				search.delete("addFeedsToSocial");

				let remaining = search.toString();

				this.props.router.navigate(this.props.router.location.pathname + (remaining ? `?${remaining}` : ""));
			}
		}

		if (this.state.promptBatchSocial && prevProps.app.loading.SOCIAL_LIST === true && this.props.app.loading.SOCIAL_LIST === false) {
			let newSocialID = _.difference(_.pluck(this.props.socials.list, "id"), _.pluck(prevProps.socials.list, 'id'));
			if (this.userHasFeeds() && newSocialID.length === 1 && !this.state.suggestFeedsSocialID) {
				this.showSuggestFeedsModal(newSocialID[0]);
			}
			this.setState({
				promptBatchSocial: false
			});
		}

	}

	componentWillUnmount() {

		posthog.reset();

	}

	pathCheck(props) {
		if (window.location.pathname.match('subscription')) {
			this.setState({
				bannerSuppressed: true
			});
		} else {
			this.setState({
				bannerSuppressed: false
			});
		}

		if (document.cookie) {
			var entries = document.cookie.split(";");
			for (var i = 0; i < entries.length; ++i) {
				var data = [],
					cookieData = {};

				if (entries[i].match('dlvrFBNotice')) {
					data = entries[i].split("=");
					cookieData = JSON.parse(decodeURIComponent(data[1]));

					if (cookieData.hideFacebookProfileNotice && cookieData.hideFacebookProfileNotice === 1) {
						this.setState({
							showFacebookProfileNotice: false
						});
					}

					break;
				}

			}
		}

		// add support for showing the social disconnect banner and modal
		// based on a param from the query
		if (window.location.search.match('reconnect=true')) {
			this.setState({
				showReconnectModal: true
			});
		}
	}

	recordPath(path) {

		this.setState({
			savedPath: path
		});

	}

	getSavedPath() {

		return this.state.savedPath;

	}

	closeInfoBanner() {
		this.setState({
			bannerVisible: false
		});
	}

	dismissModal() {
		this.setState({
			showFacebookProfileNotice: false,
			showTwitterFubarModal: false,
			showTrialEndModal: false
		});
	}

	/*
	 * The "add this social to your feeds" picker. Handed down through the
	 * Outlet context so any view that has just connected a social can open it
	 * with that social's id.
	 */
	showSuggestFeedsModal(socialID) {

		let shortCircuitModal = this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_ADVANCED ||
								this.props.router.location.pathname.match("new/outputs") ||
								this.props.router.location.pathname.match("content/post");

		if (shortCircuitModal) {
			return;
		}

		if (!this.props.socials.list.find(({id}) => parseInt(socialID, 10) === id)) {
			makeToast("Sorry, that social doesn't exist", "info");
			return;
		}

		this.setState({
			suggestFeedsSocialID: parseInt(socialID, 10) || 0
		});
	}

	hideSuggestFeedsModal() {
		this.setState({
			suggestFeedsSocialID: 0
		});
	}

	userHasFeeds() {

		let routes = this.props.automatedRoutes.list || [];

		for (let i = 0; i < routes.length; ++i) {
			if (routes[i].inputs && routes[i].inputs.length) {
				return true;
			}
		}

		return false;
	}

	render() {
		let infoBanner = null,
			bannerContent = null,
			reconnectModal = null,
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
			constants = this.props.app.config.constants,
			{ children, ...otherProps } = this.props,
			suspenseLoader = (
				<div>
					<Breakpoint desktop only>
						<Sidebar/>
					</Breakpoint>
					<Content main={<Loading/>}/>
				</div>
			),
			logoUrl = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100.png'].join(''),
			logoUrl2X = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100@2x.png'].join(''),
			showMobileBanner = false,
			mobileOnlyBanner = false,
			mobileBanner = null;

		if (this.props.app.userLoaded === false) {
			return (
				<div>
					<header className="nav-wrapper">
						<div className="nav-container">
							<div className="app-column nav left">
								<div className="logo-wrapper">
									<span className="va-helper"></span>
									<Link to="/share/automate">
										<img
					                        src={logoUrl}
											srcSet={`${logoUrl} 1x, ${logoUrl2X} 2x`}
					                        width="31px"
					                        height="100px"
					                        className="nav-logo" />
									</Link>
								</div>
							</div>
						</div>
					</header>
					<div className="content-wrapper">
						<div className="content-container">
							{suspenseLoader}
						</div>
					</div>
				</div>
			);
		}

		otherProps.getSavedPath = this.getSavedPath;
		otherProps.recordPath = this.recordPath;
		otherProps.bannerVisible = this.state.bannerVisible;
		otherProps.showSuggestFeedsModal = this.showSuggestFeedsModal;
		otherProps.userHasFeeds = this.userHasFeeds;

		if (this.state.bannerVisible && !this.state.bannerSuppressed && onboarding === null) {
			if (this.props.user.detail.pastDue) {
				showMobileBanner = true;
				bannerContent = (<PastDueBanner {...this.props}/>);
				infoBanner = (<InfoBanner type="error" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (parseInt(this.props.user.detail.pauseButton, 10) === constants.PUB_PAUSE_USER) {
				showMobileBanner = true;
				bannerContent = (<PauseBanner {...this.props}/>);
				infoBanner = (<InfoBanner type="alert" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			// } else if (this.props.user.detail.trialDaysLeft !== undefined && this.props.user.detail.trialDaysLeft >= 0) {
			// 	showMobileBanner = true;
			// 	bannerContent = (<TrialBanner {...this.props}/>);
			// 	infoBanner = <MobileOnlyBanner bannerContent={bannerContent} closeInfoBanner={this.closeInfoBanner}/>;
			// 	mobileOnlyBanner = true;
			} else if (this.state.localStorageNotice) {
				bannerContent = (<LocalStorageBanner {...this.props}/>);
				infoBanner = (<InfoBanner type="error" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (onboarding === null && (this.props.user.detail.emailActive === 0 && this.props.user.detail.bounceCount > 0)) {
				showMobileBanner = true;
				bannerContent = (<EmailValidationBanner />);
				infoBanner = (<InfoBanner type="alert" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.props.app.statuses.socialsDisconnected.length > 0) {
				showMobileBanner = true;
				bannerContent = (<SocialDisconnectBanner socialNotices={this.props.app.statuses.socialsDisconnected} {...this.props}/>);
				infoBanner = (<InfoBanner type="alert" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.props.user.plan.planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
				bannerContent = (<CardlessTrialBanner trialEndsAt={this.props.user.detail.trialEndsAt} {...this.props}/>);
				infoBanner = (<InfoBanner type="marketing" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.props.app.flags.marketing) {
				if (this.props.app.userLoaded) {
					showMobileBanner = true;
					switch (parseInt(this.props.user.detail.pubLevel, 10)) {
						case constants.PUB_LEVEL_0:
						case constants.PUB_LEVEL_1:
						case constants.PUB_LEVEL_17:
						case constants.PUB_LEVEL_15:
						case constants.PUB_LEVEL_16:
							bannerContent = (<BasicBanner {...this.props} />);
							break;

						case constants.PUB_LEVEL_2:
						case constants.PUB_LEVEL_3:
						case constants.PUB_LEVEL_6:
						case constants.PUB_LEVEL_7:
						case constants.PUB_LEVEL_8:
							bannerContent = (<ProBanner {...this.props} />);
							break;

						case constants.PUB_LEVEL_9:
						case constants.PUB_LEVEL_10:
							//bannerContent = (<PlusBanner {...this.props} />);
							break;

						default:
							break;
					}
					// Hiding the banner for now 6/30/2026
					// if (bannerContent) {
					// 	infoBanner = (<InfoBanner type="marketing-white" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
					// }
				}
			}
		}

		if (this.props.app.statuses.socialsDisconnected.length > 0 && this.state.showReconnectModal) {
			reconnectModal = (
				<ReconnectSocialModal
					{...this.props}
					setModal={() => {
						window.history.pushState("", "dlvr.it", "/share/automate");
						this.setState({showReconnectModal: false});
					}}
					socialNotices={this.props.app.statuses.socialsDisconnected}/>
			);
		}

		if (this.props.user.detail.trialDaysLeft !== undefined &&
			this.props.user.detail.trialDaysLeft <=3 &&
			this.props.user.detail.trialDaysLeft >= 0 &&
			this.state.showTrialEndModal) {
			reconnectModal = (
				<TrialEndingModal
					{...this.props}
					dismissModal={() => {
						this.setState({
							showTrialEndModal: false
						});
					}}/>
			);
		}

		if (this.state.showSetPasswordModal) {
			reconnectModal = (
				<SetPassword
					app={this.props.app}
					user={this.props.user.detail}
					updateUser={this.props.updateUser}
					apiErrors={this.props.getApiErrors(['USER_UPDATE'])}
					closeAction={(e) => {
						e.preventDefault();
						if (typeof(Storage) !== "undefined") {
							let expires = moment().add(1, 'week').format();
							window.localStorage.setItem('passwordModalSuppress', expires);
						}
						this.setState({
							showSetPasswordModal: false,
							setPasswordModalAcknowledged: true
						});
					}}/>
			);
		}

		if (this.state.showTwitterFubarModal) {
			reconnectModal = (
				<TwitterFubarModal
					{...this.props}
					dismissModal={this.dismissModal}/>
			);
		}

		if (parseInt(this.props.user.detail.pauseButton, 10) === constants.PUB_PAUSE_SYSTEM) {
			if (this.props.user.plan.pauseStart !== undefined && this.props.user.plan.pauseStart !== 0) {
				reconnectModal = (
					<RecurlySubscriptionPausedModal {...this.props} />
				);
			} else if (this.props.user.detail.hasHadSubscription &&
				(!this.props.router.location.pathname.match(/account$/) &&
				!this.props.router.location.pathname.match(/\/account\/subscription\/new/) &&
				!this.props.router.location.pathname.match(/\/account\/subscription\/compare$/) &&
				!this.props.router.location.pathname.match(/\/promo/))) {
				reconnectModal = (
					<SubscriptionPauseModal {...this.props} />
				);
			} else if (!this.props.user.detail.hasHadSubscription && (
				!this.props.router.location.pathname.match(/account$/) &&
				!this.props.router.location.pathname.match(/\/account\/subscription\/new/) &&
				!this.props.router.location.pathname.match(/\/account\/subscription\/compare$/) &&
				!this.props.router.location.pathname.match(/\/promo/))) {
				reconnectModal = (
					<TrialEndedModal {...this.props} />
				);
			}
		} else if (this.props.user.detail.hasSnapshot) {
			let hasSeenSnapshotModal = window.sessionStorage.getItem('hasSeenSnapshotModal');
			if (hasSeenSnapshotModal === null || hasSeenSnapshotModal === false) {
				if (this.props.user.detail.hasHadSubscription && (
					!this.props.router.location.pathname.match(/account$/) &&
					!this.props.router.location.pathname.match(/\/account\/subscription\/new/) &&
					!this.props.router.location.pathname.match(/\/account\/subscription\/compare$/) &&
					!this.props.router.location.pathname.match(/\/promo/))) {
					reconnectModal = (
						<SubscriptionPauseModal {...this.props} />
					);
				} else if (!this.props.user.detail.hasHadSubscription && (
					!this.props.router.location.pathname.match(/account$/) &&
					!this.props.router.location.pathname.match(/\/account\/subscription\/new/) &&
					!this.props.router.location.pathname.match(/\/account\/subscription\/compare$/) &&
					!this.props.router.location.pathname.match(/\/promo/))) {
					reconnectModal = (
						<TrialEndedModal {...this.props} />
					);
				}
			}
		} else if (this.state.showWelcomeBackModal) {
			reconnectModal = (
				<WelcomeBack
					{...this.props}
					dismissModal={() => {
						if (typeof(Storage) !== undefined) {
							localStorage.setItem('welcomeBackModalSeen', true);
						}
						this.setState({
							showWelcomeBackModal: false
						});
					}} />
			);
		}

		/*
		 * Last, and only into an empty slot: it gives way to every other login
		 * modal, the subscription and trial ones included, and shows once they
		 * are dismissed. Done comes from state rather than the session flag,
		 * which the notice writes before its modal opens.
		 */
		if (!reconnectModal && !this.state.xQrCodesNoticeDone && xQrCodesNoticeApplies(this.props)) {
			reconnectModal = (
				<XQrCodesNotice
					app={this.props.app}
					socials={this.props.socials}
					appName={this.props.appName}
					router={this.props.router}
					getSocial={this.props.getSocial}
					updateSocial={this.props.updateSocial}
					getApiErrors={this.props.getApiErrors}
					registerCallback={this.props.registerCallback}
					unregisterCallback={this.props.unregisterCallback}
					onDone={() => {
						this.setState({
							xQrCodesNoticeDone: true
						});
					}}/>
			);
		}

		if (showMobileBanner && infoBanner) {
			mobileBanner = infoBanner
		}

		let containerClass = 'content-container';
		if (this.props.router.location.pathname.match("/subscription/new") ||
			this.props.router.location.pathname.match("/subscription/compare") ||
			this.props.router.location.pathname.match("/promo")) {
			containerClass += ' subscription';
		}

		let bannerFlagClass = '';
		if (infoBanner && !mobileOnlyBanner) {
			bannerFlagClass += 'with-banner';
		}

		let suggestFeedsModal = null;

		if (this.state.suggestFeedsSocialID) {
			suggestFeedsModal = (
				<NewSocialSuggestFeedsModal
					socialID={this.state.suggestFeedsSocialID}
					socials={this.props.socials}
					automatedRoutes={this.props.automatedRoutes}
					constants={this.props.app.config.constants}
					createOutput={this.props.createOutput}
					apiErrors={this.props.getApiErrors(['OUTPUT_CREATE'])}
					deleteApiError={this.props.deleteApiError}
					closeAction={this.hideSuggestFeedsModal}
					onComplete={() => this.props.getRoutes()}/>
			);
		}

		let trialWidget = null,
			showWidget = (window.sessionStorage.getItem('showWidget') !== null) ? false : true;

		// if (showWidget && this.props.user.detail.trialDaysLeft !== undefined && !this.props.router.location.pathname.match("/subscription/new")) {
		// 	trialWidget = (
		// 		<TrialWidget
		// 			{...this.props}/>
		// 	);
		// }

		return(
			<ErrorBoundary level="top" {...this.props}>
				<div className={bannerFlagClass}>
					{this.props.modals.stack.map((Component, i) => {
						let { children, ...otherProps } = this.props;
						otherProps.key = "modal-" + i;
						return React.cloneElement(Component, otherProps, children);
					})}
					{reconnectModal}
					{suggestFeedsModal}
					<Toaster
						position="top-right"
						toastOptions={{
							classNames: {
								closeButton: '!right-0 !left-auto !translate-x-1/2 !top-0 !-translate-y-1/2',
							}
						}}
						mobileOffset={{bottom: "100px"}}/>
					<Breakpoint desktop only>
						<AnimatePresence>
							{infoBanner}
						</AnimatePresence>
						<Nav {...this.props}/>
						<IntercomWidgetControl displayHelp={true}/>
					</Breakpoint>
					<Breakpoint mobile only>
						{mobileBanner}
						<MobileNav {...this.props}/>
						<IntercomWidgetControl displayHelp={false}/>
					</Breakpoint>
					<div className="content-wrapper">
						<div className={containerClass}>
							<div aria-hidden={this.props.modals.stack.length  ? true : false}>
								<Outlet context={otherProps}/>
							</div>
						</div>
					</div>
					{trialWidget}
				</div>
			</ErrorBoundary>
		);
	}
};

App.displayName = "DlvritApp";

const enhance = compose(
	ComponentWithRouter,
	PersistData,
	AppProvider,
	NotificationProvider,
	UserProvider,
	PlanProvider,
	UtilityProvider,
	ModalProvider,
	SubscriptionModule,
	SocialProvider,
	RouteProvider,
	AuthModule,
	SocialConnectModule
);

App.propTypes = {
	fetchUser: PropTypes.func,
	appName: PropTypes.string
};

App.defaultProps = {
	fetchUser: () => {},
	appName: "dlvr"
};

export default enhance(App);
